import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';


export interface ListColumnConfigg {
      id?: number;
      field: string;
      label: string;
      entity: string;
      isVisible: boolean;
      valueSource: string;
      isSortable: boolean;
      width: number;
      seq: number;
      filterType?: string | null;
      relationEntity?: string | null;
      relationField?: string | null;
}
export interface PagedResult<T> {
      items: T[];
      totalCount: number;
}
@Injectable({ providedIn: 'root' })
export class ListConfigService {
      // Add the full origin to match your backend port
      private baseUrl = `${environment.apiUrl}/api/sys/listconfig`      ;

      constructor(private http: HttpClient) { }

      // Hits the endpoint that returns EVERY entity in the table
//       getAll(): Observable<ListColumnConfigg[]> {
//     return this.http.get<ListColumnConfigg[]>(`${this.baseUrl}/all`)
// }
      getAll(pageIndex: number, pageSize: number, searchTerm: string = ''): Observable<PagedResult<ListColumnConfigg>> {
            // Build query parameters: /all?pageIndex=0&pageSize=10&searchTerm=abc
            let params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString())
                  .set('searchTerm', searchTerm);

            return this.http.get<PagedResult<ListColumnConfigg>>(`${this.baseUrl}/all`, { params });
      }
      // This matches your [HttpGet("{entity}")]
      getConfig(entity: string): Observable<ListColumnConfigg[]> {
            return this.http.get<ListColumnConfigg[]>(`${this.baseUrl}/${entity}`);
      }

      create(data: ListColumnConfigg): Observable<number> {
            return this.http.post<number>(this.baseUrl, data);
      }

      // This matches the [HttpPut] we just added to the controller
      update(data: ListColumnConfigg): Observable<number> {
            return this.http.put<number>(this.baseUrl, data);
      }

      delete(id: number): Observable<number> {
            return this.http.delete<number>(`${this.baseUrl}/${id}`);
      }
}